export default {
  "submit-app_page-title": "Health Saving Account Application",
  "submit-app_page-description": "Welcome! Qualified applicants can open an account quickly and easily.",
  "___submit-app_step_personal-information": "",
  "___submit-app_step_contact-information": "",
  "___submit-app_step_account": "",
  "___submit-app_step_banking": "",
  "___submit-app_step_review": "",
  "___submit-app_step_terms-and-conditions": "",
  "___submit-app_action_done": "",
  "submit-app_title_hsa-application": "HSA Application",
  "submit-app_title_enter-personal-information": "Enter personal information",
  "___submit-app_title_personal-information": "",
  "submit-app_title_enter-contact-information": "Enter contact information",
  "___submit-app_title_contact-information": "",
  "submit-app_title_enter-account-information": "Enter account information",
  "___submit-app_title_account-information": "",
  "submit-app_title_enter-banking-information": "Enter banking information",
  "___submit-app_title_banking-information": "",
  "___submit-app_title_terms-and-conditions": "",
  "submit-app_title_review": "Please review",
  "submit-app_label_personal-information": "Personal Information",
  "___submit-app_action_edit-personal-information": "",
  "submit-app_label_contact-information": "Contact Information",
  "___submit-app_action_edit-contact-information": "",
  "submit-app_label_account-information": "Account Information",
  "___submit-app_action_edit-account-information": "",
  "submit-app_label_banking-information": "Banking Information",
  "___submit-claim_label_name": "",
  "submit-app_label_ssn": "SSN",
  "submit-app_label_offer-code": "Offer Code",
  "submit-app_label_us-address-line-3": "Address Line 3",
  "submit-app_label_recurring-pull-date": "Recurring Pull Date",
  "submit-app_label_address": "Address",
  "___submit-app_action_edit-banking-information": "",
  "___submit-app_action_submit": "",
  "submit-app_action_register": "Register",
  "submit-app_action_register-later": "Register Later",
  "submit-app_action_start-application": "Start Application",
  "___submit-app_action_cancel": "",
  "___submit-app_title_confirm-close": "",
  "___submit-app_text_confirm-close": "",
  "___submit-app_action_confirm-close_cancel": "",
  "___submit-app_action_confirm-close_confirm": "",
  "___submit-app_action_continue": "",
  "___submit-app_action_print": "",
  "___submit-app_action_skip": "",
  "submit-app_action_print-application": "Print Application",
  "___submit-app_form-hint_dob": "",
  "submit-app_option_drivers-license": "Driver's License",
  "submit-app_option_passport": "Passport",
  "submit-app_option_state-issued-id": "State-Issued ID",
  "submit-app_text_validate-hsa-applicant_loading-message": "Validating Applicant Information…",
  "submit-app_text_validate-contact-info_loading-message": "Validating Contact Information…",
  "submit-app_text_get-group-plan-types_loading-message": "Loading Account Information…",
  "submit-app_text_get-irs-limits_loading-message": "Loading Banking Information…",
  "submit-app_text_submit_loading-message": "Submitting HSA Application…",
  "___submit-app_form-hint_zip": "",
  "___submit-app_form-hint_phone": "",
  "___submit-app_option_single": "",
  "___submit-app_option_family": "",
  "submit-app_option_1st-of-month": "1st of Each Month",
  "submit-app_option_5th-of-month": "5th of Each Month",
  "submit-app_option_10th-of-month": "10th of Each Month",
  "submit-app_option_15th-of-month": "15th of Each Month",
  "submit-app_option_25th-of-month": "25th of Each Month",
  "___submit-app_option_checking": "",
  "___submit-app_option_savings": "",
  "submit-app_text_over-hard-limit": "This contribution will put you over the maximum allowed by the IRS for the tax year.",
  "submit-app_action_over-hard-limit_cancel": "Ok",
  "submit-app_text_over-soft-limit": "Based on the information you provided regarding your age and health plan coverage, this contribution may put you over the maximum allowed by the IRS for the tax year. Do you want to continue?",
  "___submit-app_action_over-soft-limit_cancel": "",
  "___submit-app_action_over-soft-limit_confirm": "",
  "submit-app_text_no-bank-entered": "No bank entered",

  // FORM LABELS
  "submit-app_form-label_offer-code": "Offer code? Enter here",
  "___submit-app_form-label_first-name": "",
  "submit-app_form-label_middle-initial": "Middle Initial",
  "___submit-app_form-label_last-name": "",
  "___submit-app_form-label_dob": "",
  "___submit-app_form-label_ssn": "",
  "submit-app_form-label_form-of-id": "Form of ID",
  "submit-app_form-label_id-number": "ID Number",
  "___submit-app_form-label_state-of-issuance": "",
  "submit-app_form-header_sponsored-hsa": "Which best applies to your application?",
  "submit-app_form-label_individual-hsa": "I am opening a Further HSA as an individual",
  "submit-app_form-label_employer-sponsored-hsa": "My Employer is offering a Further HSA",
  "submit-app_form-label_group-number": "Group Number",
  "submit-app_form-label_group-name": "Group Name",
  "submit-app_form-label_agent": "Are you working with an agent or broker?",
  "submit-app_form-label_agent-no": "No",
  "submit-app_form-label_agent-yes": "Yes",
  "submit-app_form-label_agent-number": "Agent Number",
  "submit-app_form-label_non-us-address": "Non-US Address",
  "___submit-app_form-label_addr-1": "",
  "___submit-app_form-label_addr-2": "",
  "___submit-app_form-label_non-us-addr-1": "",
  "___submit-app_form-label_non-us-addr-2": "",
  "___submit-app_form-label_non-us-addr-3": "",
  "___submit-app_form-label_city": "",
  "___submit-app_form-label_state": "",
  "___submit-app_form-label_zip": "",
  "submit-app_form-label_phone": "Phone Number",
  "submit-app_form-label_phone-mobile": "Check if this is a mobile number",
  "___submit-app_form-label_email": "",
  "submit-app_form-label_confirm-email": "Confirm Email",
  "submit-app_form-label_health-plan-carrier": "Health Plan Carrier",
  "submit-app_form-label_health-plan-coverage": "Health Plan Coverage",
  "submit-app_form-label_hsa-plan": "HSA Type",
  "submit-app_form-label_health-plan-effective-date": "Health Plan Effective Date",
  "submit-app_form-label_hsa-effective-date": "HSA Effective Date",
  "___submit-app_form-label_routing-number": "",
  "___submit-app_form-label_account-number": "",
  "___submit-app_form-label_confirm-account-number": "",
  "___submit-app_form-label_bank-name": "",
  "___submit-app_form-label_account-type": "",
  "submit-app_form-label_one-time-deposit": "Make a one-time deposit",
  "submit-app_form-label_one-time-amount": "One-time Amount",
  "submit-app_form-label_expected-post-date": "Expected Post Date",
  "submit-app_form-label_tax-year": "Tax Year",
  "submit-app_form-label_recurring-deposit": "Make a recurring deposit",
  "submit-app_form-label_recurring-amount": "Monthly Deposit Amount",
  "submit-app_form-label_monthly-deposit-day": "Monthly Deposit Day",
  "submit-app_form-label_terms-and-conditions": "I agree to the Terms & Conditions stated.",
  "submit-app_text_no-address-matches": "No address matches found. Please enter a complete address.",
  "submit-app_text_loading-message_validating-address": "Please wait, your details are being verified",
  "submit-app_text_loading-message_validating-email": "Please wait, your details are being verified",

  // FORM ERRORS
  "submit-app_form-error_offer-code_max-length": "Offer code cannot be longer than %maxLength% characters.",
  "submit-app_form-error_offer-code_invalid": "Offer code can only contain alphanumeric characters.",
  "___submit-claim_form-error_first-name_required": "",
  "submit-app_form-error_first-name_length": "First name cannot be longer than %maxLength% characters.",
  "submit-app_form-error_middle-initial_length": "Middle initial cannot be longer than %maxLength% characters.",
  "___submit-claim_form-error_last-name_required": "",
  "submit-app_form-error_last-name_length": "Last name cannot be longer than %maxLength% characters.",
  "___submit-app_form-error_dob_required": "",
  "submit-app_form-error_dob_invalid-format": "The Date of Birth entered is invalid",
  "submit-app_form-error_dob_invalid-dob": "The Date of Birth cannot be a future date.",
  "submit-app_form-error_dob_invalid-dob-age": "You must be 18 years of age to open an HSA account",
  "___submit-app_form-error_ssn_required": "",
  "submit-app_form-error_ssn_invalid-format": "The SSN must be 9 digits in length",
  "submit-app_form-error_ssn_invalid": "The SSN entered is invalid",
  "submit-app_form-error_form-of-id_required": "Select a form of ID",
  "___submit-app_form-error_id-number_required": "",
  "submit-app_form-error_id-number_length": "ID number cannot be longer than %maxLength% characters.",
  "___submit-app_form-error_state-of-issuance_required": "",
  "___submit-app_form-error_group-number_required": "",
  "submit-app_form-error_group-number_length": "Group number cannot be longer than %maxLength% characters.",
  "submit-app_form-error_group-number_invalid": "Invalid Group Number",
  "___submit-app_form-error_group-name_required": "",
  "submit-app_form-error_group-name_length": "Group name cannot be longer than %maxLength% characters.",
  "___submit-app_form-error_agent-number_required": "",
  "submit-app_form-error_agent-number_length": "Agent number cannot be longer than %maxLength% characters.",
  "___submit-app_form-error_addr-1_required": "",
  "submit-app_form-error_addr-1_max-length": "Address Line 1 cannot be longer than %maxLength% characters.",
  "submit-app_form-error_addr-2_max-length": "Address Line 2 cannot be longer than %maxLength% characters.",
  "___submit-app_form-error_city_required": "",
  "submit-app_form-error_city_max-length": "City cannot be longer than %maxLength% characters.",
  "___submit-app_form-error_state_required": "",
  "___submit-app_form-error_zip_required": "",
  "submit-app-error_zip_invalid-format": "The Zip Code must be 5 or 9 digits in length",
  "submit-app_form-error_non-us-addr-1_required": "Address line 1 is required",
  "submit-app_form-error_non-us-addr-1_max-length": "Address Line 1 cannot be longer than %maxLength% characters.",
  "submit-app_form-error_non-us-addr-2_max-length": "Address Line 2 cannot be longer than %maxLength% characters.",
  "submit-app_form-error_non-us-addr-3_required": "Address line 3 is required",
  "submit-app_form-error_non-us-addr-3_max-length": "Address Line 3 cannot be longer than %maxLength% characters.",
  "submit-app_form-error_primary-phone_required": "Phone number is required",
  "submit-app_form-error_primary-phone_invalid-format": "The Phone Number must be 10 digits in length",
  "___submit-app_form-error_email_required": "",
  "submit-app_form-error_email_invalid-format": "The Email Address entered is invalid",
  "submit-app_form-error_email_invalid-length": "Email cannot be longer than %maxLength% characters.",
  "submit-app_form-error_confirm-email_required": "Re-enter the email",
  "submit-app_form-error_confirm-email_same-as": "The Email Addresses entered do not match",
  "___submit-app_form-error_health-plan-carrier_required": "",
  "___submit-app_form-error_health-plan-coverage_required": "",
  "___submit-app_form-error_hsa-plan_required": "",
  "submit-app_form-error_health-plan-effective-date_invalid-format": "The Health Plan Effective Date is invalid",
  "submit-app_form-error_hsa-effective-date_invalid-format": "The HSA Effective Date is invalid",
  "submit-app_form-error_hsa-effective-date_after-default": "The HSA Effective Date cannot be prior to %compareDate%",
  "submit-app_form-error_hsa-effective-date_invalid-date-range": "The Effective Date must fall within group plan year",
  "submit-app_form-error_account-type_required": "Select the account type",
  "submit-app_form-error_routing-number_required": "Enter the routing number",
  "submit-app_form-error_routing-number_invalid-format": "Invalid Routing Number",
  "submit-app_form-error_routing-number_invalid": "The Routing number entered is invalid",
  "submit-app_form-error_routing-number_length": "The Routing Number must be 9 digits in length",
  "submit-app_form-error_account-number_required": "Enter the account number",
  "submit-app_form-error_account-number_invalid-format": "Invalid Account Number",
  "submit-app_form-error_account-number_maxlength": "Account number cannot be longer than %maxLength% characters",
  "submit-app_form-error_confirm-account-number_required": "Re-enter the account number",
  "submit-app_form-error_confirm-account-number_same-as": "The Account Numbers entered do not match",
  "submit-app_form-error_bank-name_required": "Please enter a valid routing number",
  "submit-app_form-error_one-time-amount_required": "",
  "submit-app_form-error_one-time-amount_min-value": "A minimum deposit amount of $5 is required to establish your HSA.",
  "submit-app_form-error_one-time-amount_negative": "The deposit amount must be a positive number",
  "submit-app_form-error_expected-post-date_date": "Please enter a valid deposit date.",
  "submit-app_form-error_expected-post-date_required": "Select a deposit date",
  "submit-app_form-error_expected-post-date_after-default-date": "Please enter a deposit date in the future and greater than your account effective date.",
  "submit-app_form-error_expected-post-date_before-end-date": "Deposit date must be prior to %compareDate%",
  "submit-app_form-error_tax-year_required": "Select a tax year",
  "submit-app_form-error_recurring-amount_required": "",
  "submit-app_form-error_recurring-amount_negative": "The deposit amount must be a positive number",
  "submit-app_form-error_recurring-amount_min-value": "Deposit amount must be greater than $0.00.",
  "submit-app_form-error_monthly-deposit-day_required": "Select a monthly deposit day",
  "___submit-app_form-error_terms-and-conditions_required": "",
  "submit-app-redirect": "https://www.healthequity.com/open-an-hsa"
};